import ArtistComboBox from "./ArtistComboBox";
import ArtistsSearch from "./ArtistsSearch";
import Timeline from "./Timeline";
import PressList from "./PressList";
import Publications from "./Publications";
import PublicationsList from "./Publications/PaginatedList";
import NewsList from "./NewsList";
import ExhibitionsList from "./ExhibitionsList";
import PublicationSlider from "./PublicationSlider";
import SelectedWorksDropdown from "./SelectedWorksDropdown";
import ExhibitionsLanding from "./ExhibitionsLanding";
import ExhibitionTeaser from "./ExhibitionTeaser";
import ExhibitionsOnView from "./ExhibitionsOnView";
import LoadingAnimation from "./LoadingAnimation";

export default {
  ArtistComboBox,
  ArtistsSearch,
  Timeline,
  PressList,
  Publications,
  PublicationsList,
  NewsList,
  ExhibitionsList,
  PublicationSlider,
  SelectedWorksDropdown,
  ExhibitionsLanding,
  ExhibitionTeaser,
  ExhibitionsOnView,
  LoadingAnimation,
};
